exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CloseButton__root___3L3e9{text-align:right;cursor:pointer;float:right;padding:8px;font-size:30px;position:absolute;top:-2px;right:16px}.CloseButton__root___3L3e9 img{width:24px;height:24px}@media (max-width:450px){.CloseButton__root___3L3e9{top:-8px;right:6px}}.CloseButton__padded___2sOWD{padding:10px}.CloseButton__small___3m9E8 img{width:16px;height:16px}", ""]);

// exports
exports.locals = {
	"root": "CloseButton__root___3L3e9",
	"padded": "CloseButton__padded___2sOWD",
	"small": "CloseButton__small___3m9E8"
};